import React from 'react';
import {Button, PlainButton} from 'ui-kit';

import {
  BenefitsModal,
  EditPlanForm,
  PlanHistoryModal,
  PlanText,
} from './components';

import * as styles from './Member.module.css';

export function Member({
  member,
  membershipPlans,
  hasPaymentSource,
  sourceLast4,
  openPaymentModal,
  onBenefitUseSubmit,
  onEditPlanSubmit,
}) {
  const [planSelectVisible, setPlanSelectVisible] = React.useState(false);
  const [benefitsModalOpen, setBenefitsModalOpen] = React.useState(false);
  const [planHistoryModalOpen, setPlanHistoryModalOpen] = React.useState(false);

  const {
    firstName,
    lastName,
    membershipPlanSubscriptions,
    primaryAccountHolder,
    email,
    phone,
  } = member;

  const activeSubscription = membershipPlanSubscriptions.find(
    subscription => subscription.status === 'ACTIVE',
  );

  return (
    <div className={styles.Container}>
      <div>
        <p>
          <strong>
            {firstName} {lastName}
          </strong>
        </p>

        {primaryAccountHolder ? (
          <p className={styles.PrimaryAccountHolderText}>
            <strong>
              <small>Primary account holder</small>
            </strong>
          </p>
        ) : null}

        {email == null ? null : (
          <p>
            <small>{email}</small>
          </p>
        )}

        {phone == null ? null : (
          <p>
            <small>{phone}</small>
          </p>
        )}
      </div>

      {planSelectVisible ? (
        <EditPlanForm
          memberId={member.id}
          availablePlans={membershipPlans}
          onSubmit={async () => {
            await onEditPlanSubmit();
            setPlanSelectVisible(false);
          }}
          onCancel={() => setPlanSelectVisible(false)}
          hasPaymentSource={hasPaymentSource}
          sourceLast4={sourceLast4}
          openPaymentModal={openPaymentModal}
        />
      ) : (
        <div className={styles.PlanContainer}>
          <div className={styles.PlanTextContainer}>
            <PlanText
              activeSubscription={activeSubscription}
              allSubscriptions={membershipPlanSubscriptions}
            />
          </div>

          {activeSubscription == null ? (
            <>
              <Button
                color="light"
                size="small"
                onClick={() => setPlanSelectVisible(true)}
                disabled={membershipPlans.length === 0}
              >
                Edit plan
              </Button>
              {membershipPlans.length === 0 ? (
                <p>
                  <small>
                    There are no plans available for your practice.{' '}
                    <PlainButton to="/plans/new">
                      <small>Create one</small>
                    </PlainButton>
                  </small>
                </p>
              ) : null}
            </>
          ) : (
            <div className={styles.TrackBenefitsButton}>
              <Button size="small" onClick={() => setBenefitsModalOpen(true)}>
                Track benefits
              </Button>

              <BenefitsModal
                show={benefitsModalOpen}
                onDismiss={() => setBenefitsModalOpen(false)}
                onSubmit={onBenefitUseSubmit}
                firstName={member.firstName}
                lastName={member.lastName}
                membershipPlanSubscriptionId={activeSubscription.id}
                benefits={activeSubscription.membershipPlan.benefits}
                benefitUses={activeSubscription.benefitUses}
              />
            </div>
          )}

          {membershipPlanSubscriptions.length > 0 ? (
            <div className={styles.PlanHistoryContainer}>
              <Button
                size="small"
                color="light"
                onClick={() => setPlanHistoryModalOpen(true)}
              >
                View plan history
              </Button>

              <PlanHistoryModal
                show={planHistoryModalOpen}
                onDismiss={() => setPlanHistoryModalOpen(false)}
                subscriptions={membershipPlanSubscriptions}
                firstName={member.firstName}
                lastName={member.lastName}
              />
            </div>
          ) : null}
        </div>
      )}
    </div>
  );
}
